import { ref, onBeforeMount, Ref } from 'vue';
import { cloneDeep, pick } from 'lodash';
import { useViewComposable } from '@/views/composable';

export const useMixinsRoom = (dialogRef: Ref) => {
  const room = dialogRef?.value?.data?.data;
  const isManagement = dialogRef?.value?.data?.isManagement;
  const priority = dialogRef?.value?.data?.priorityStatus;
  const retDate = dialogRef?.value?.data?.retDate;
  const listPassenger = dialogRef?.value?.data?.listPassenger;
  const listChildren = dialogRef?.value?.data?.listChildren;
  const allowCopy = dialogRef?.value?.data?.allowCopy;
  const isMdt = dialogRef?.value?.data?.isMdt;
  const expandedRows = ref([]);
  const occupancy = ref([]);

  const passengerInfo = {
    age: 0,
    lastName: '',
    firstName: '',
    middleName: '',
    title: '',
    dateOfBirth: null,
    telephone: '',
    email: '',
    roomRequests: [],
    aeroPlan: '',
    seatingPreference: '',
    passport: {
      passportNumber: '',
      nationality: '',
      expiryDate: null,
      countryOfIssue: ''
    }
  };

  const today = ref(new Date());

  const columns = [
    { label: 'book_form.single', name: 'Single', field: 'single', peopleNo: 1 },
    { label: 'book_form.double', name: 'Double', field: 'double', peopleNo: 2 },
    { label: 'book_form.triple', name: 'Triple', field: 'triple', peopleNo: 3 },
    { label: 'book_form.quad', name: 'Quad', field: 'quad', peopleNo: 4 },
    { label: 'book_form.five', name: 'Five', field: 'fiveInRoom', peopleNo: 5 },
    { label: 'book_form.six', name: 'Six', field: 'sixInRoom', peopleNo: 6 }
  ];

  const initAdultPassengers = (number: number) => {
    const adults = [];
    for (let i = 0; i < number; i++) {
      const cloneInfo = cloneDeep(passengerInfo);
      adults.push({ ...cloneInfo });
    }
    return adults;
  };

  const formatInfants = (infants: any, cIndex: number, roomIndex: number) => {
    if (infants) {
      return infants.map((infant: any, index: number) => {
        return {
          ...infant,
          key: `infant${cIndex}${roomIndex}${index}`
        };
      });
    }
    return [];
  };

  const formatChildren = (children: any, cIndex: number, roomIndex: number) => {
    if (children) {
      return children.map((children: any, index: number) => {
        return {
          ...children,
          key: `children${cIndex}${roomIndex}${index}`
        };
      });
    }
    return [];
  };
  const initOccupancy = () => {
    const roomInfo = cloneDeep(room);
    if (roomInfo?.roomInfo) {
      columns.forEach((column, cIndex) => {
        const numberPeople = pick(room, ['maxPaxAdult', 'maxPaxChild', 'maxPaxRoom', 'minAdPerChild', 'minPaxAdult', 'minPaxChild', 'minPaxRoom']);
        if (roomInfo.roomInfo?.[`${column.field}No`]) {
          const passengers = [];
          for (let i = 0; i < roomInfo.roomInfo[`${column.field}No`]; i++) {
            const roomList = roomInfo.roomInfo[`${column.field}RoomInfos`] && cloneDeep(roomInfo.roomInfo[`${column.field}RoomInfos`][i]);
            if (roomList) {
              passengers.push({
                key: `passengers${cIndex}${i}`,
                people: roomList.adtPassengers,
                email: roomList?.email,
                roomRequests: roomList?.roomRequests,
                children: formatChildren(roomList.chdPassengers, cIndex, i),
                infants: formatInfants(roomList.infPassengers, cIndex, i)
              });
            } else {
              passengers.push({
                key: `passengers${cIndex}${i}`,
                email: roomList?.email,
                roomRequests: roomList?.roomRequests,
                people: initAdultPassengers(column.peopleNo),
                children: [],
                infants: []
              });
            }
          }
          occupancy.value.push({ ...numberPeople, label: column.label, field: column.field, passengers });
        }
      });
    }
  };
  const titles = [
    { title: 'Mr', code: 'Mr' },
    { title: 'Mrs', code: 'Mrs' },
    { title: 'Ms', code: 'Ms' },
    { title: 'Dr', code: 'Dr' },
    { title: 'Mstr', code: 'Mstr' },
    { title: 'Miss', code: 'Miss' },
    { title: 'Inf', code: 'Inf' }
  ];
  const seatPrefOption = [
    { type: 'aisle', code: 'A' },
    { type: 'window', code: 'W' },
    { type: 'extra leg room', code: 'E' }
  ];

  onBeforeMount(() => {
    if (dialogRef?.value?.data) {
      dialogRef.value.data.occupancy = occupancy.value;
    }
    initOccupancy();
  });

  const checkPriorityBooking = (status: string | number | undefined) => {
    const { statusPriorityNumber } = useViewComposable();
    return !isManagement && Number(status) === statusPriorityNumber.NINE;
  };
  return {
    room,
    isManagement,
    expandedRows,
    occupancy,
    passengerInfo,
    columns,
    today,
    titles,
    seatPrefOption,
    retDate,
    listPassenger,
    allowCopy,
    listChildren,
    initOccupancy,
    priority,
    checkPriorityBooking,
    isMdt,
    formatInfants,
    formatChildren
  };
};
